export function initialize(module: ng.IModule) {
    module.controller("ListsController", ListsController);

    ListsController.$inject = [];
}

function ListsController() {
    var vm = this;

    vm.tabs = getTabs();
    vm.selectedIndex = 0;

    vm.greeting = "Greeting from the ListsController";



    function getTabs() {
        return [
            { title: 'Workplaces', content: "Tabs will become paginated if there isn't enough room for them." },
            { title: 'Activity Types', content: "You can swipe left and right on a mobile device to change tabs." },
            { title: 'Job Titles', content: "You can bind the selected tab via the selected attribute on the md-tabs element." },
            { title: 'Authorities', content: "If you set the selected tab binding to -1, it will leave no tab selected." },
        ];
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/lists/lists.controller.ts